// ─── useStockPrices.js ───────────────────────────────────────
// Hook care face UN SINGUR fetch pt toate preturile
// Se foloseste in componenta parent (Stocks page)

import { useState, useEffect } from "react";
import axios from "axios";
import proxy from "../proxy";

const useStockPrices = () => {
  const [prices, setPrices] = useState({});   // { "O": 63.23, "IBKR": 74.59, ... }
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${proxy}server_mts/GetStockPrices.php`, {
        headers: { "Cache-Control": "no-cache" },
      })
      .then((res) => {
        // Converteste array-ul in map: ticker -> price
        const priceMap = {};
        if (Array.isArray(res.data)) {
          res.data.forEach((item) => {
            priceMap[item.ticker] = item.price;
          });
        }
        setPrices(priceMap);
      })
      .catch(() => setError("Unable to fetch stock prices"))
      .finally(() => setIsLoading(false));
  }, []);

  return { prices, isLoading, error };
};

export default useStockPrices;


// ─── Exemplu de utilizare in Stocks page ─────────────────────
//
// import useStockPrices from "../hooks/useStockPrices";
// import Stock from "./Stock";
//
// const StocksPage = () => {
//   const { prices, isLoading: pricesLoading } = useStockPrices();
//   const [stocks, setStocks] = useState([]);
//
//   // ... fetch stocks from GetStocks.php ...
//
//   return (
//     <Table>
//       <Tbody>
//         {stocks.map((stock) => (
//           <Stock
//             key={stock.ticker}
//             stock={stock}
//             price={prices[stock.ticker] || null}
//             isLoading={pricesLoading}
//           />
//         ))}
//       </Tbody>
//     </Table>
//   );
// };